import React from 'react';

function Plus() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
    </svg>
  );
  /* eslint-enable */
}

export default Plus;



// WEBPACK FOOTER //
// ./src/common/icons/Plus.js